/**
 * Enumeration of all possible component states for the StateViewComponent.
 */
export enum State {
  Empty = 'empty',
  Loading = 'loading',
  Content = 'content',
  Error = 'error'
}


/**
 * Merges the given collection of states into a single state. This function prioritizes the Error state (if at least
 * one constituent state is Error, then the merged state is Error), followed by Loading, followed by Content. The
 * Empty state is only used if all constituent states are Empty or undefined.
 * @param states {State} Individual constituent states to merge
 * @returns {State} Merged state
 */
export function mergeStates(...states: State[]): State {
  if (states.some(s => s === State.Error)) {
    return State.Error;
  }
  if (states.some(s => s === State.Loading)) {
    return State.Loading;
  }
  if (states.some(s => s === State.Content)) {
    return State.Content;
  }
  return State.Empty;
}
